import axios from '../api/index'
export const sendNotification = async (state) =>{
    const data = state
    const emailSent = await axios.requestData('post','/notifications',data)
    return emailSent.data
}